<template>
  <v-flex>
    <v-divider></v-divider>
    <v-list-tile :key="alert.id" class="alertListTile">

      <v-list-tile-content>
        <v-list-tile-title>{{ alert.description }}</v-list-tile-title>
      </v-list-tile-content>

      <v-list-tile-action class="alertRowAction">
        <v-switch :id="alertActiveToggleId(alert.id)" :aria-checked="isActive" role="switch" v-model="isActive"></v-switch>
      </v-list-tile-action>

      <v-list-tile-action class="alertRowAction">
        <alert-row-action :alert="alert"/>
      </v-list-tile-action>

    </v-list-tile>
  </v-flex>
</template>
<script>
  import { SET_ALERT_ACTIVE_TOGGLE } from '../../../store/mutation-types'
  import AlertRowAction from './AlertRowAction'
  import { UPDATE_ALERT_ACTIVE_CRITERIA } from '../../../store/action-types'

  export default {
    name: 'alert-table-row',
    components: {AlertRowAction},
    props: {
      alert: {
        type: Object
      },
      alertKey: {
        type: Number
      }
    },
    methods: {
      alertActiveToggleId (key) {
        return `alert-${key}-active`
      }
    },
    computed: {
      isActive: {
        get () {
          return this.alert.active
        },
        set (value) {
          this.$store.commit(SET_ALERT_ACTIVE_TOGGLE, {alertId: this.alert.id, active: value})
          this.$store.dispatch(UPDATE_ALERT_ACTIVE_CRITERIA, {alertId: this.alert.id, active: value})
        }
      }
    }
  }
</script>
<style scoped>
  .alertRowAction {
    width: 60px
  }
</style>



// WEBPACK FOOTER //
// src/components/settings/alert/AlertTableRow.vue